/** 课程中心 **/

// 课程发布
const AddCommodity = () => import('@pv/courseCenter/commodity/AddCommodity');

// 课程发布
const Empty = () => import('@pv/courseCenter/commodity/Empty');

// 商品详情
const CommodityDetail = () =>
  import('@pv/courseCenter/commodity/CommodityDetail');

// 商品管理
const CommodityTable = () => import('@pv/courseCenter/commodity/CommodityTable');

// 课程资源管理列表
const CourseTable = () => import('@pv/courseCenter/resources/CourseTable');

// 课程资源校验
const CourseTableCheck = () => import('@pv/courseCenter/resources/Check');

// 新建/编辑课程
const EditCurriculum = () => import('@pv/courseCenter/resources/EditCurriculum');

// 课程资源导入
const BatchNewCourses = () =>
  import('@pv/courseCenter/resources/BatchNewCourses');

// 课程设置-分类管理
const CourseClassify = () =>
  import('@pv/courseCenter/courseSetting/CourseClassify.vue');

// 课程设置-其他管理
const CourseOthers = () =>
  import('@pv/courseCenter/courseSetting/CourseOthers.vue');

// 运营端 - 商品管理 - 课程套餐
const ComboTable = () => import('@pv/courseCenter/commodity/Combo/ComboTable');
// 运营端 - 商品管理 - 课程套餐  编辑添加
const EditCombo = () => import('@pv/courseCenter/commodity/Combo/EditCombo');
// 运营端 - 优惠券 - 优惠券管理
const CouponIndex = () => import('@pv/courseCenter/coupon/Index');
// 运营端 - 优惠券 - 编辑优惠券
const CouponEdit = () => import('@pv/courseCenter/coupon/Edit');

// 运营端 - 商品管理 - 材料管理
const MaterialTable = () =>
  import('@pv/courseCenter/commodity/Material/MaterialTable');

export default [
  {
    path: '/courseCenter/commodity/commodityTable',
    name: 'courseCenter_commodity_commodityTable',
    meta: {
      title: '课程商品',
      activePath: '/courseCenter/commodity/commodityTable',
      breadcrumb: '课程中心-商品管理-课程商品'
    },
    component: CommodityTable
  },
  {
    path: '/courseCenter/commodity/commodityTable/addCommodity',
    name: 'courseCenter_commodity_addCommodity_addCommodity',
    meta: {
      title: '课程发布',
      activePath: '/courseCenter/commodity/commodityTable',
      breadcrumb: '课程中心-商品管理-课程商品-课程发布'
    },
    component: AddCommodity
  },
  {
    path: '/courseCenter/commodity/commodityTable/empty',
    name: 'courseCenter_commodity_addCommodity_empty',
    meta: {
      title: '课程发布',
      activePath: '/courseCenter/commodity/commodityTable',
      breadcrumb: '课程中心-商品管理-课程商品-课程发布'
    },
    component: Empty
  },
  {
    path: '/courseCenter/commodity/commodityTable/commodityDetail',
    name: 'courseCenter_commodity_commodityTable_commodityDetail',
    meta: {
      title: '商品详情',
      activePath: '/courseCenter/commodity/commodityTable/commodityDetail',
      breadcrumb: '课程中心-商品管理-课程商品-商品详情'
    },
    component: CommodityDetail
  },
  {
    path: '/courseCenter/resources/courseTable',
    name: 'courseCenter_resources_courseTable',
    meta: {
      title: '课程资源',
      activePath: '/courseCenter/resources/courseTable',
      breadcrumb: '课程中心-资源管理-课程资源'
    },
    component: CourseTable
  },
  {
    path: '/courseCenter/resources/check',
    name: 'courseCenter_resources_check',
    meta: {
      title: '课程资源',
      activePath: '/courseCenter/resources/check',
      breadcrumb: '课程中心-资源管理-资源校验'
    },
    component: CourseTableCheck
  },
  {
    path: '/courseCenter/resources/courseTable/edit',
    name: 'courseCenter_resources_courseTable_edit',
    meta: {
      title: '编辑课程',
      activePath: '/courseCenter/resources/courseTable',
      breadcrumb: '课程中心-资源管理-课程资源-编辑课程'
    },
    component: EditCurriculum
  },
  {
    path: '/courseCenter/resources/courseTable/batchNewCourses',
    name: 'courseCenter_resources_courseTable_batchNewCourses',
    meta: {
      title: '批量新建课程',
      activePath: '/courseCenter/resources/courseTable',
      breadcrumb: '课程中心-资源管理-课程资源-批量新建课程'
    },
    component: BatchNewCourses
  },

  {
    path: '/courseCenter/commodity/comboTable',
    name: 'courseCenter_commodity_comboTable',
    meta: {
      title: '课程套餐',
      activePath: '/courseCenter/commodity/comboTable',
      breadcrumb: '课程中心-商品管理-课程套餐'
    },
    component: ComboTable
  },

  {
    path: '/courseCenter/commodity/comboTable/addCombo',
    name: 'courseCenter_commodity_comboTable_addCombo',
    meta: {
      title: '课程套餐',
      activePath: '/courseCenter/commodity/comboTable',
      breadcrumb: '课程中心-商品管理-课程套餐-添加套餐'
    },
    component: EditCombo
  },
  {
    path: '/courseCenter/commodity/comboTable/editCombo',
    name: 'courseCenter_commodity_comboTable_editCombo',
    meta: {
      title: '课程套餐',
      activePath: '/courseCenter/commodity/comboTable',
      breadcrumb: '课程中心-商品管理-课程套餐-编辑套餐'
    },
    component: EditCombo
  },
  {
    path: '/courseCenter/courseSetting/courseClassify',
    name: 'courseCenter_courseSettings_courseClassify',
    meta: {
      title: '分类管理',
      activePath: '/courseCenter/courseSetting/courseClassify',
      breadcrumb: '课程中心-课程设置-分类管理',
      filterShowChangeSchool: [0], // 显示切换学校按钮 只显示在某个特定端
      showChangeSchool: true // 显示切换学校按钮
    },
    component: CourseClassify
  },
  {
    path: '/courseCenter/courseSetting/courseOthers',
    name: 'courseCenter_courseSetting_courseOthers',
    meta: {
      title: '其他设置',
      activePath: '/courseCenter/courseSetting/courseOthers',
      breadcrumb: '课程中心-课程设置-其他设置'
    },
    component: CourseOthers
  },
  {
    path: '/courseCenter/coupon/index',
    name: 'courseCenter_coupon_index',
    meta: {
      title: '优惠券管理',
      activePath: '/courseCenter/coupon/index',
      breadcrumb: '课程中心-优惠券-优惠券管理'
    },
    component: CouponIndex
  },
  {
    path: '/courseCenter/coupon/index/add',
    name: 'courseCenter_coupon_index_add',
    meta: {
      title: '优惠券添加',
      activePath: '/courseCenter/coupon/index',
      breadcrumb: '课程中心-优惠券-优惠券添加'
    },
    component: CouponEdit
  },
  {
    path: '/courseCenter/coupon/index/edit',
    name: 'courseCenter_coupon_index_edit',
    meta: {
      title: '优惠券编辑',
      activePath: '/courseCenter/coupon/index',
      breadcrumb: '课程中心-优惠券-优惠券编辑'
    },
    component: CouponEdit
  },

  {
    path: '/courseCenter/commodity/materialTable',
    name: 'courseCenter_commodity_materialTable',
    meta: {
      title: '材料管理',
      activePath: '/courseCenter/commodity/materialTable',
      breadcrumb: '课程中心-商品管理-材料管理'
    },
    component: MaterialTable
  }
];
